import BaseService from './baseService';

class ActivityFeedService {   
    static getActivityFeed() {
        return BaseService.getAndReturn(`/ActivityFeed`, BaseService.returnAssignedArray, 'Unable to fetch activity feed', true);
    }
}
export default ActivityFeedService;